import React, { useContext } from "react";
import styled from "styled-components";
import { AppContext } from "../../AppProvider";
import { IC } from "../../../resources/Assets";

export const InputDivSearch = (props) => {
  const { searchEvent } = props;
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const clickEvent = () => {
    searchEvent(userinfo, cfg, phonecfg, "A", $("#tags").val(), setSearchList);
    $("#ui-id-1").show();
  };

  const searchEventEnter = () => {
    if (window.event.keyCode == 13) {
      searchEvent(
        userinfo,
        cfg,
        phonecfg,
        "A",
        $("#tags").val(),
        setSearchList
      );
      $("#ui-id-1").show();
    }
  };

  return (
    <SearchArea className="autocomplete">
      <div style={{ width: "90%" }}>
        <input
          id="tags"
          type="text"
          placeholder="병원명을 입력해주세요."
          onKeyUp={() => searchEventEnter()}
          style={{ height: "50px", border: "0" }}
        />
      </div>
      <div>
        <BtnSearch onClick={() => clickEvent()} />
      </div>
    </SearchArea>
  );
};

const BtnSearch = styled.a`
  position: absolute;
  width: 42px;
  height: 42px;
  background: url("${IC.etc.IC_GRAY_SEARCH}") no-repeat center;
  background-size: 23px;
`;

const SearchArea = styled.div`
  padding: 0px 15px;
  height: 50px;
  border: 1px solid #d0d0d0;
  border-radius: 7px;
  font-size: 14px;
  display: flex;
`;
